import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the AddBeerHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'add-beer-header',
  templateUrl: 'add-beer-header.html',
  styleUrls: ['./add-beer-header.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class AddBeerHeaderComponent {

  text: string;

  constructor(private translateService: TranslateService) {
    // WARN this will only work in a normal workflow, not when this page is set as the home page
    this.text = this.translateService.instant('ADDBEER.ADD_BEER');
  }

}
